import React, { useEffect, useState } from "react";
import "./css/DataCleanUp.css";
import LoadingSpinner from './LoadingSpiner';
import CalculatePoints from "./CalculatePoints";
import NewCSVPopup from "./NewCSVPopup";

function FISDataCleanUp(props) {
    const csvData = props.csvData;
    const setCsvData = props.setCsvData;
    const headerInfo = props.headerInfo;
    const setHeaderInfo = props.setHeaderInfo;


    // STATES
    const [isLoading, setIsLoading] = useState(false);
    // popup for showing the changes that will be made to the csv data from the fis DB
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const  originalData = headerInfo.originalData;

    // FUNCTIONS
    const handlePopupClose = () => {
        setIsPopupOpen(false);
        setPopupData(null);
    };

    const checkForMissingRacers = async (data, licenceList) => {
        //Data is the JSON we got back from FISPoints lambda and licenceList is the list of all FISLicences in our race.
        
        //The first part is a sub functions for parsing the returned XML results the other lambda that gets called 
        //inside this parent function below
        const parseXMLString = (xmlString) => {
            let result = {};

            if (!xmlString) {
                console.error('Received undefined or null XML string');
                return null;
            }

            // Splitting XML string based on tags
            const tags = xmlString.split('<');

            for(let i = 0; i < tags.length; i ++){
                if(tags[i].includes('sectorcode="CC"')){
                    for( let j = i; j < tags.length; j++){
                        //  if its not a closing tag
                        const tagContent = tags[j].split('>')[1];
                        if (tagContent && !tagContent.includes('\n')) {
                            // Trim all values to handle inconsistent whitespace from FIS XML
                            const trimmedContent = tagContent.trim();
                            if (tags[j].includes('fiscode>')) {
                                result['fiscode'] = trimmedContent;
                            }
                            if (tags[j].includes('lastname>')) {
                                result['lastname'] = trimmedContent;
                            }
                            if (tags[j].includes('firstname>')) {
                                result['firstname'] = trimmedContent;
                            }
                            if (tags[j].includes('gender>')) {
                                result['gender'] = trimmedContent;
                            }
                            if (tags[j].includes('nationcode>')) {
                                result['nationcode'] = trimmedContent;
                            }
                            if (tags[j].includes('year>')) {
                                result['year'] = trimmedContent;
                            }
                            if (tags[j].includes('status>')) {
                                result['status'] = trimmedContent;
                            }
                            if (result['fiscode'] && result['lastname'] && result['firstname'] && result['gender'] && result['nationcode'] && result['year'] && result['status']) {
                                break;
                            }
                        }
                    }
                } 
            }
            return Object.keys(result).length > 0 ? result : null;

        }

        //This is the **actual** start of this function from a readability standpoint
        //Data is the JSON we got back from FISPoints lambda and licenceList is the list of all FISLicences in our race.
        //Push all the returned FISCodes from the JSON onto a list of knownRacers - there were found in the FISpoints list
        let knownRacers = [];
        (data || []).forEach((racer) => {
            // Normalize to string AND trim to handle any whitespace inconsistencies from APIs
            knownRacers.push(String(racer['fis_licence']).trim())
        })
        // take the full licenceList of every licence in our race and filter out the known racers returned from the api
        //- leaving us with FIScodes that are NOT in the current FIS points list
        // Normalize to string AND trim to ensure consistent comparison
        const FIScodes = licenceList.filter(racer => !knownRacers.includes(String(racer).trim()))
        console.log('122: Not known people:', FIScodes, '(knownRacers count:', knownRacers.length, ')')

        // We then want to hit the CORS proxi/website api for them and add thei names, country and yob, and make sure they are active
        if(FIScodes.length > 0) {
            await new Promise(resolve => setTimeout(resolve, 1000));

            console.log('127: hitting CORS proxy api for racers:', FIScodes)
            //This is the CORS proxy to hit FIS website to check current status and names of people who aren't in the current list
            //This returns a JSON dict of the raw XML from the FIS website
            let apiUrl = 'https://p474fmngovil3jmfzxh75fuvg40ksjuf.lambda-url.us-west-2.on.aws/'
            console.log('129:' + apiUrl)

            try{
                // Send a GET request to the API endpoint using fetch
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ FIScodes }),
                });      
    
                if (!response.ok) {
                    throw new Error(`142: HTTP error! Status: ${response.status}`);
                }
            
                // Parse the XML response
                const returnedFISData = await response.json()
                FIScodes.forEach((FISID) => {  
                    if(!returnedFISData[FISID]){
                        console.log('149: NO FIS XML FOR:', FISID)
                        console.log('150: NO FIS XML Data FOR:', returnedFISData[FISID])
                    }
                    //Take the XML and convert it to a JSON junk (if CCSector data)
                    let parsedData = parseXMLString(returnedFISData[FISID])
                    if(parsedData){
                        const parsedFiscode = parsedData['fiscode'];
                        const dataMatches = String(parsedFiscode).trim() === String(FISID).trim();
                        console.log(FISID + 'status=' + parsedData['status'] + ' parsedFiscode=' + parsedFiscode + ' match=' + dataMatches)
                        
                        if (!dataMatches) {
                            console.warn('WARNING: CORS proxy returned wrong data! Requested ' + FISID + ' but got ' + parsedFiscode);
                        }
                        
                        //Push them onto the data structure including STATUS so we can clean the CSV including their data 
                        //and erase them from the CSV if they are inactive
                        let personInfo = {}
                        personInfo['competior_id'] = null
                        // CRITICAL: Use FISID (what we requested) for fis_licence so matching works
                        // The CORS proxy sometimes returns wrong person's data, so we use the requested ID
                        personInfo['fis_licence'] = FISID
                        // Only use the XML data if it matches what we requested, otherwise keep CSV values
                        if (dataMatches) {
                            personInfo['last_name'] = parsedData['lastname']
                            personInfo['first_name'] = parsedData['firstname']
                            personInfo['gender'] = parsedData['gender']
                            personInfo['date_of_birth'] = parsedData['year']
                            personInfo['nation'] = parsedData['nationcode']
                        } else {
                            // Data doesn't match - use placeholder values, don't apply wrong person's data
                            personInfo['last_name'] = null
                            personInfo['first_name'] = null
                            personInfo['gender'] = null
                            personInfo['date_of_birth'] = null
                            personInfo['nation'] = null
                        }
                        personInfo['fis_points'] = {'DI': null, 'SP': null}  //Can't have any points if parsing from website
                        personInfo['status'] = dataMatches ? parsedData['status'] : 'O'  // Assume valid if we can't verify
                        data.push(personInfo) //Append them to the data structure
                    }
                })
    
            
               } catch (error) {
                     console.error('Error fetching data for FIS racers from FIS information lambda', error.message);
               }
            //Finally return data which is the origional data returned from the first points API call along with the 
            //website records appended at the bottom - the only difference in the records is the website ones will have a status 
            //property whereas the points ones will not
            return data
        } else {
            return data
        }
    }

/*
            // hit the fis api for each fis list untill it returns one
            //let apiUrl = `https://www.fis-ski.com/DB/general/search.html?search=${notKnownRacers[i]}&feed=false&byfiscode=true`
            let apiUrl = 'https://p474fmngovil3jmfzxh75fuvg40ksjuf.lambda-url.us-west-2.on.aws/'
            console.log(apiUrl)

            //try {
                // Send a GET request to the API endpoint using fetch
                const response = await fetch(apiUrl);
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
                }
            
                // Parse the XML response
                const xmlData = await response.text()
                console.log('parsing xml for racer:', notKnownRacers[i])
                let parsedData = await parseXMLString(xmlData)
                console.log('xml parse result:', parsedData)

                if(parsedData){
                    // this is the person to add
                    let personInfo = {}
                    personInfo['first_name'] = parsedData['firstname']
                    personInfo['last_name'] = parsedData['lastname']
                    personInfo['gender'] = parsedData['gender']
                    personInfo['nation'] = parsedData['nationcode']
                    personInfo['fis_licence'] = parsedData['fiscode']
                    personInfo['date_of_birth'] = parsedData['year']
                    personInfo['fis_points'] = {'DI': null, 'SP': null}
                    personInfo['status'] = parsedData['status']
                    data.push(personInfo)
                }
            
              //} catch (error) {
              // console.error(`Error fetching data for racer ${notKnownRacers[i]}:`, error.message);
              //}
        }
        return data
    }
*/
    //This is the entry point for the cleanup routines for FIS
    const getFisData = () => {
        console.log('230: getFisData started')
        setIsLoading(true);

        // Identify racers without FIS codes first
        const initialRacersWithoutFIS = csvData.filter(racer => !racer["FIScode"]);

        // Create the list of racers to actually process (those *with* FIS codes)
        let racersToProcess = csvData.filter(racer => racer["FIScode"]);

        // Re-rank the racers being processed (skip for sprint finals - rankings are by Highest Round, already calculated)
        if (headerInfo.format !== 'sprintFinal') {
            racersToProcess = reRankInitial(racersToProcess);
        }

        console.log(`235: Starting with ${csvData.length}, Processing ${racersToProcess.length}, Initially removed ${initialRacersWithoutFIS.length}`);

        //Make a list of all the FIS licences in the remaining CSV data and save it to variable 'racers'
        var racers = [];
        racersToProcess.forEach((row) => { // Use the filtered list
            if(row["FIScode"]){
                racers.push(row["FIScode"]);
            }
        });
        

        var points_list = parseInt(headerInfo['usedFISList']);

        //Send that list of FIS codes 
        console.log('249 length of racers=' + racers.length)  //22

        const data_to_send = new FormData();
        data_to_send.append('points_list', points_list);
        data_to_send.append('racers', racers);  //This list of FISlicences assembled above
        data_to_send.append('return_csv', false);

        /*
        Call FIS Lambda that looks up list of FIS codes in the latest points list and returns JSON dict that looks like:
        [
            {
                "competior_id": "225619",
                "fis_licence": "3195319",
                "last_name": "DUCHAUFOUR",
                "first_name": "Eve Ondine",
                "gender": "W",
                "date_of_birth": "2001-10-04",
                "nation": "FRA",
                "fis_points": {
                    "DI": "95.34",
                    "SP": "148.32"
                }
            },
        */
        try{
            fetch("https://ggpwjy2pju3cttzzmoxhnuidyi0bkuwd.lambda-url.us-west-2.on.aws", {
            method: 'POST',
            body: data_to_send
            })
            .then(response => response.json())
            .then(data => {
                if(data["message"] === undefined){
                    console.log ("287 data=", data)
                    //Now not everyone will be found in the latest points list
                    //For FIS licences that aren't found in the current points list, we need to look them up on FIS website
                    //to ensure they are active
                    //We're sending the same list of FISlicences we assembed above - our current list of FISLicences in the CSV File
                    //along with the JSON we got back from the FISPoints lambda function api call we made above, 
                    //And we're sending it to this function checkForMissingRacers
                    //this function appends more records to the data structure which it gets from the lookup of website records
                    checkForMissingRacers(data, racers)
                    .then((result)=>{
                        //result should be just like data along with the website records
                        console.log("results returned from checkForMissingRacers", result);

                        // Pass the API results, the list of racers *processed*, and the initially removed racers
                        const popupPayload = changeCSVData(result, racersToProcess, initialRacersWithoutFIS);

                        setIsLoading(false);
                        setPopupData(popupPayload); // Pass the object { validRacers, removedRacers }
                        setIsPopupOpen(true);
                    })
                    .catch((err)=>{
                        console.warn('Error:', err)
                    })
                }
                else{
                    window.alert(data["message"]);
                    setIsLoading(false);
                }
            })
        } catch (error) {
            console.error('Error fetching data for FIS racers from FIS points lambda', error.message);
        }
    }

    // Define helper functions here so changeCSVData can access them
    const checkNames = (apiRow, row) => {
        // if they are the same then set the first name and last name to the values from the api
        // Don't overwrite with null (happens when CORS proxy returns wrong person's data)
        if(apiRow["first_name"] && row["firstname"] !== apiRow["first_name"]){
            row["firstname"] = apiRow["first_name"]
        };

        if(apiRow["last_name"] && row["lastname"] !== apiRow["last_name"]){
            row["lastname"] = apiRow["last_name"]
        };
    };

    const checkFISPoints = (apiRow, row) => {
        // if they are the same then set the FISpoints to the values from the api
        // Ensure discipline points exist before comparing/assigning
        const disciplinePoints = apiRow["fis_points"]?.[headerInfo["discipline"]];
        if(disciplinePoints !== undefined && row["FISpoints"] !== disciplinePoints){
            row["FISpoints"] = disciplinePoints;
        };
    };

    const addFISPoints = (apiRow, row) => {
        // if they are the same then set the FISpoints to the values from the api
        let points = null
        try{
            // Ensure discipline points exist before trying to parse
            const disciplinePoints = apiRow["fis_points"]?.[headerInfo["discipline"]];
            if (disciplinePoints !== undefined && disciplinePoints !== null) {
                 points = parseFloat(disciplinePoints);
            }
        } catch(err) {
            points = null; // Keep null if parsing fails
        }
        row["FISpoints"] = points;
        // Return 1 if points were successfully added (or attempted), 0 otherwise
        return (points !== null && !isNaN(points)) ? 1 : 0; 
    };

    const checkNationality = (apiRow, row) => {
        if(apiRow['nation'] && row["Country"] !== apiRow['nation']){
            row["Country"] = apiRow["nation"];
            return 1;
        }
        return 0;
    };

    const checkYOB = (apiRow, row) => {
        // Ensure date_of_birth exists before trying to split
        if(apiRow['date_of_birth']) {
            const apiYOB = apiRow['date_of_birth'].split("-")[0];
            if(row["YOB"] !== apiYOB){
                row["YOB"] = apiYOB;
                return 1;
            }
        }
        return 0;
    };

    const addGender = (apiRow, row) => {
        // Don't overwrite with null (happens when CORS proxy returns wrong person's data)
        if (apiRow['gender']) {
            row['sex'] = apiRow['gender'];
        }
    };

    // Helper function to re-rank initially filtered racers (similar to original checkForNonFISLicenceRacers)
    const reRankInitial = (filteredData) => {
        let position = 0;
        let lastTime = null;
        let lastRank = 0;
        filteredData.sort((a, b) => {
            // Basic time sort, assuming format or add parsing
            const timeA = parseFloat(a.time?.replace(':', '.')) || Infinity;
            const timeB = parseFloat(b.time?.replace(':', '.')) || Infinity;
            return timeA - timeB;
        });
        filteredData.forEach((racer) => {
            if(racer['status'] === '' || racer['status'] === 'QLF'){
                position++;
                const currentTime = racer["time"];
                if(currentTime !== lastTime){
                    racer["rank"] = position; // New time = rank equals position
                } else {
                    racer["rank"] = lastRank; // Tie = keep same rank
                }
                lastRank = racer["rank"];
                lastTime = currentTime;
            } else {
                racer["rank"] = ''; // Assign empty rank for non-finishers
                lastTime = null; // Reset for next group of finishers
            }
        });
        return filteredData;
    };

    const changeCSVData = (data, racersWhoHadFISCode, initiallyRemovedRacers) => {
        // Data = json dict from both API lookups (points list + website lookup)
        // racersWhoHadFISCode = original csv data filtered to only include rows with a FIScode

        let finalProcessedData = []; // Build a new list instead of modifying in place
        let apiRemovedRacers = []; // Keep track of racers identified as invalid by API

        let add_nation = 0;
        let add_YOB = 0;
        let add_fis_points = 0;

        console.log('375 data=', data);
        console.log('376 racersWhoHadFISCode before processing=', racersWhoHadFISCode);
        
        // DEBUG: Log all fis_licence values in the data array
        const allFisLicencesInData = data.map(r => String(r['fis_licence']).trim());
        console.log('DEBUG: All fis_licence values in API data:', allFisLicencesInData);

        // Use map to create the initial list, makes filtering easier later if needed
        const initialProcessedRows = racersWhoHadFISCode.map((row) => {
            let matchFoundInApiData = false;
            let modifiedRow = { ...row }; // Work on a copy
            let isValidAccordingToApi = true; // Assume valid unless proven otherwise

            // Loop through all results from the API lookups
            data.forEach((apiRow) => {
                // Check if the API result matches the current CSV row
                // Normalize both to strings AND trim to handle any whitespace inconsistencies
                if (String(row["FIScode"]).trim() === String(apiRow["fis_licence"]).trim()) {
                    matchFoundInApiData = true; // We found this racer in the API results

                    // --- Perform updates based on API data ---
                    checkNames(apiRow, modifiedRow);
                    addGender(apiRow, modifiedRow);
                    if (modifiedRow["FISpoints"]) {
                        checkFISPoints(apiRow, modifiedRow);
                    } else {
                        add_fis_points += addFISPoints(apiRow, modifiedRow);
                    }
                    add_nation += checkNationality(apiRow, modifiedRow);
                    add_YOB += checkYOB(apiRow, modifiedRow);
                    // --- End Updates ---

                    // Check the status from the API result (only website lookup provides status)
                    if (apiRow["status"] === 'E') {
                        console.log('Marking racer as invalid due to Status E:', row["FIScode"]);
                        isValidAccordingToApi = false; // Mark as invalid
                    }
                    // No need to continue inner loop once a match is found and processed
                    return; // Exit inner forEach early (optimization) - this doesn't work with forEach, logic continues below
                }
            });

            // After checking all API results for the current row:
            if (!matchFoundInApiData) {
                // If the racer from the CSV wasn't found in *any* API result (neither points list nor website)
                const csvCode = String(row["FIScode"]).trim();
                console.log('Marking racer as invalid - not found in any API result:', csvCode);
                console.log('DEBUG: Looking for "' + csvCode + '" in data. Is it present?', allFisLicencesInData.includes(csvCode));
                console.log('DEBUG: Data fis_licence values:', allFisLicencesInData.filter(x => x.includes(csvCode.substring(0,4))));
                isValidAccordingToApi = false;
            }

            // Return the processed row along with its validity status
            return { processedRow: modifiedRow, isValid: isValidAccordingToApi, originalRow: row };
        });

        // Separate valid and removed racers
        finalProcessedData = initialProcessedRows
            .filter(item => item.isValid)
            .map(item => item.processedRow);

        apiRemovedRacers = initialProcessedRows
            .filter(item => !item.isValid)
            .map(item => ({ racer: item.originalRow, reason: "INVALID (Status E or Not Found)" })); // Format for popup

        // Re-ranking logic (applied to the filtered valid data) - simplified as we rebuild the list
        // Skip for sprint finals - rankings are by Highest Round, already calculated
        if (headerInfo.format !== 'sprintFinal') {
            let position = 0;
            let lastTime = null; // Use null to handle first racer correctly
            let lastRank = 0;
            finalProcessedData.forEach((racer) => {
                if (racer['status'] === '' || racer['status'] === 'QLF') {
                    position++;
                    const currentTime = racer["time"]; 
                    if (currentTime !== lastTime) {
                        racer["rank"] = position; // New time = rank equals position
                    } else {
                        racer["rank"] = lastRank; // Tie = keep same rank
                    }
                    lastRank = racer["rank"];
                    lastTime = currentTime;
                } else {
                    // Reset rank logic for non-finishers if needed, or assign null/empty rank
                     racer["rank"] = ''; // Or null, depending on desired output for DNF/DNS etc.
                     lastTime = null; // Reset time comparison for next finisher
                }
            });
        }


        // --- Header modification logic ---
        let headers = headerInfo.headers;
        if (add_nation > 0 && !headers.includes('Country')) {
            headers.push('Country');
        }
        if (add_YOB > 0 && !headers.includes('YOB')) {
            headers.push('YOB');
        }
        if (add_fis_points > 0 && !headers.includes('FISpoints')) {
            headers.push('FISpoints');
        }
        // Update headerInfo state if headers changed
        if (add_nation > 0 || add_YOB > 0 || add_fis_points > 0) {
            setHeaderInfo((prevState) => ({
                ...prevState,
                 "headers": headers
            }));
        }
        // --- End Header modification ---

        console.log('Final processed data being returned:', finalProcessedData);

        // Combine initially removed racers (no FIS code) with API-removed racers
        const allRemovedRacers = [
            ...initiallyRemovedRacers.map(racer => ({ racer: racer, reason: "MISSING FIS Code" })),
            ...apiRemovedRacers
        ];

        // Return both valid and removed racers in the structure expected by the popup
        return { validRacers: finalProcessedData, removedRacers: allRemovedRacers };
    };

    // calculate the top 5 racers with the lowest FISpoints. this is hard coded and needs to change depending on the fild of the csv.
    const calculateTop5Racers = () => {
    const sortedPeople = [...csvData].sort(
      (a, b) => a["FISpoints"] - b["FISpoints"]
    );
    
    const filteredRacers = sortedPeople.filter(
      racer => racer.rank >= 1 && racer.rank <= 5
    );
    
    const sortedFilteredRacers = [...filteredRacers].sort(
      (a, b) => a.rank - b.rank
    );
    // set the header info wutht he top 5 racers
    setHeaderInfo((prevState) => ({
        ...prevState,
        "top5Racers":sortedFilteredRacers
        }));
    } 

    // make the popup visable or not
    const ToggleCalculatePenalty = () => {
    // create popup for calculating penalty
    const overlay = document.getElementById('overlay');
    if (overlay.style.display === 'flex') {
      overlay.style.display = 'none';
    }
    else {
      overlay.style.display = 'flex';
      calculateTop5Racers();
    }

    }

    useEffect(() => {
        console.log('original data changed:', originalData)
    }, [originalData])


  return (
    <>
      <div id="dataCleanUp">
        <div id="dataCleanUpBox">
          <div id="instr">
            Once you have imput all the correct info for the Header Section. you
            can then calculate the FIS points for the race if they do not have
            any. First you can check the data agenst the FIS database. To do so
            use the button below. Then you can calculate the FIS points.
          </div>
          <button id="checkData" onClick={getFisData} disabled={isLoading || !csvData || !(csvData.length > 0)}>
            {isLoading ? <LoadingSpinner /> : "Check Data against FIS Data"}
          </button>
          <button id="calcAndTog" onClick={ToggleCalculatePenalty} disabled={!csvData || !(csvData.length > 0) || headerInfo.format === 'sprintFinal'}>
            Calculate Penalty / Race Points
          </button>
        </div>

        <div id="calculate-points">
            <CalculatePoints headerInfo={headerInfo} setHeaderInfo={setHeaderInfo} csvData={csvData} setCsvData={setCsvData} ToggleCalculatePenalty={ToggleCalculatePenalty}/>
        </div>
      </div>

      <NewCSVPopup
        isPopupOpen={isPopupOpen}
        closeWindow={handlePopupClose}
        newData={popupData}
        oldData={originalData}
        headerInfo={headerInfo}
        headers={headerInfo.headers}
        setCsvData={setCsvData}
        setHeaderInfo={setHeaderInfo}
        callerContext="FIS"
      />

    </>
  );
}

export default FISDataCleanUp;